import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import { TAB } from '../../../constants';
import { SectionHeader } from '../StyledDropdownComponents';

class BaseAllHeaderView extends Component {
    static propTypes = {
        tab: PropTypes.number.isRequired,
    };

    render() {
        const {
            tab,
        } = this.props;

        switch (tab) {
            case TAB.PLAN:
                return (
                    <SectionHeader data-test="all-header">
                        <FormattedMessage
                            defaultMessage="all plans"
                            id="Components.InsurancePicker.AllPlans.Header"
                        />
                    </SectionHeader>
                );
            case TAB.BCBS:
                return (
                    <SectionHeader data-test="all-header">
                        <FormattedMessage
                            defaultMessage="all BCBS carriers"
                            id="Components.InsurancePicker.AllBcbs.Header"
                        />
                    </SectionHeader>
                );
            default:
                return (
                    <SectionHeader data-test="all-header">
                        <FormattedMessage
                            defaultMessage="all carriers"
                            id="Components.InsurancePicker.AllCarriers.Header"
                        />
                    </SectionHeader>
                );
        }
    }
}

export const AllHeaderView = injectIntl(BaseAllHeaderView);
